"use client";

import type { FormatOptions } from "date-fns/format";
import { format } from "date-fns/format";
import { enUS } from "date-fns/locale/en-US";
import { useCallback, useEffect, useState } from "react";

import type { Locale } from "../types/locale.types";
import { useLocale } from "../useIntl";
import { getDateLocale } from "../utils/getDateFormatter";

export const useDateFormatter = () => {
  const locale = useLocale();
  const [dateFnsLocale, setDateFnsLocale] = useState(enUS);

  useEffect(() => {
    getDateLocale(locale as Locale).then(setDateFnsLocale);
  }, [locale]);

  return useCallback(
    (dt: Date, formatStr: string, options?: FormatOptions) => {
      const formatOptions = { ...options, locale: dateFnsLocale };
      return format(dt, formatStr, formatOptions);
    },
    [dateFnsLocale],
  );
};
